import LinkHelper from '@wetransfer/transfer/component/navigation/helpers/link';
import Links from '@wetransfer/transfer/component/navigation/links';
import {
  FF_NAV_SIGN_UP_EXPERIMENT,
  FF_REFERRAL_PROGRAM,
} from '@wetransfer/transfer/constant/experiments';
import {
  userHasFreeTier,
  userHasPremium2022Tier,
  userHasPro2022Tier,
  userHasPlusTier,
} from '@wetransfer/transfer/helper/user';
import { getVariant } from '@wetransfer/transfer/modules/experiments';

//
// During page load users should see
// Login / Spinner
//
// Anonymous user should see
// Pricing Features Company Help Signup Login
//
// Free user should see
// Portals Transfers Contacts Branding Upgrade <sep> [Account menu]
//
// Pro user should see
// Portals Transfers Contacts Branding Upgrade <sep> [Account menu]
//
// Prem user should see
// Portals Transfers Contacts Branding <sep> [Account menu]
//

const anonymousUser = (user) => {
  let navigation = {
    pricing: Links.pricingItem,
    about: Links.aboutItem,
    help: Links.helpItem,
    account: Links.loginItem,
  };

  if (getVariant(FF_NAV_SIGN_UP_EXPERIMENT) === 'variant-c') {
    navigation = LinkHelper.attachFeaturesExperimentLink(navigation);
  }

  navigation = LinkHelper.attachFeaturesMenu(navigation, user);
  navigation = LinkHelper.attachSignupLink(navigation);

  return navigation;
};

const freeUser = (user) => {
  let navigation = {
    transfers: Links.transfersItem,
    contacts: Links.contactsItem,
    branding: Links.brandingItem,
  };

  navigation = LinkHelper.attachFeaturePortalsLink(navigation);
  navigation = LinkHelper.attachUpgradeAccountLink(navigation, user);

  return navigation;
};

const proUser = (user) => {
  let navigation = {
    transfers: Links.transfersItem,
    contacts: Links.contactsItem,
    branding: Links.brandingItem,
  };
  navigation = LinkHelper.attachFeaturePortalsLink(navigation);
  navigation = LinkHelper.attachUpgradeAccountLink(navigation, user);

  if (getVariant(FF_REFERRAL_PROGRAM) === 'on') {
    navigation = LinkHelper.attachReferralLink(navigation);
  }

  return navigation;
};

const premiumUser = () => {
  let navigation = {
    transfers: Links.transfersItem,
    contacts: Links.contactsItem,
    branding: Links.brandingItem,
  };
  navigation = LinkHelper.attachFeaturePortalsLink(navigation);

  if (getVariant(FF_REFERRAL_PROGRAM) === 'on') {
    navigation = LinkHelper.attachReferralLink(navigation);
  }

  return navigation;
};

export default {
  create: (user, isLoading) => {
    if (isLoading) {
      return Object.values({ account: Links.loadingItem });
    } else if (!user.loggedIn) {
      return Object.values(anonymousUser(user));
    } else if (userHasFreeTier(user)) {
      return Object.values(freeUser(user));
    } else if (userHasPro2022Tier(user) || userHasPlusTier(user)) {
      return Object.values(proUser(user));
    } else if (userHasPremium2022Tier(user)) {
      return Object.values(premiumUser(user));
    }

    // Either an unmapped tier, or an invalid login state
    // error
  },
};
